<template>
  <div id="lngcross">
    <!-- In lounge component -->

    <!-- {{crosssell_data_passed.data[0].sub_venue_id}} -->

    <div class="loading-results" v-if="!dataloaded">
      <span>
        <i class="fas fa-circle-notch fa-spin"></i>&nbsp;
        {{ getrans("Loading Lounge Options") }}...</span
      >
    </div>

    <div class="loading-results" v-if="noSlotsAvailable">
      {{ getrans("Sorry, Lounge not available for the moment.") }}

      <SearchWidget
        :brand_slug="setbrandid"
        brand_theme="light"
        :custom_class="`large-strings no-background no-shadow`"
        showTabs="lounge"
        activeTab="lounge"
        hideTabs="true"
        :dateStart="date1_forwidget"
        dateEnd=""
        :lang="lang.toLowerCase()"
        :venue_select="venue_select"
        emit_search="true"
        :adults_select="adults_select"
        :children_select="children_select"
        :infants_select="infants_select"
        :senior_select="senior_select"
        :loading_data="loading_data_widget ? 'true' : 'false'"
        :hide_venue_select="`true`"
        :button-text="`Update`"
        :key="refresh_widget"
      />
    </div>

    <div class="results-fade" :class="dataloaded ? '' : 'not-loaded'">
      <div class="results" v-if="finalloungeresults">
        <!-- ignore this loop for now it is for different types of fasttrack -->

        <!-- {{finalloungeresults}} -->

        <!-- {{ adults_select }}
      {{ children_select }}
      {{ infants_select }}
      {{ senior_select }} -->

        <template v-for="(item, i) in finalloungeresults" :key="i">
          <div class="results_box">
            <!-- doesnt expand area -->

            <!-- {{ get_lngdetails(item.lounge_id) }}
            {{lang}} -->

            <div class="results_top">
              <div class="results_top_image_title_description">
                <img
                  :src="
                    get_lngdetails(item.lounge_id)['lounge_image_main_' + lang]
                  "
                  class="results_top_image"
                />

                <div class="results_top_title_description">
                  <div class="results_top_title">
                    <span
                      ><b>{{
                        getrans(get_lngdetails(item.lounge_id).lounge_label)
                      }}</b>
                    </span>
                  </div>
                  <div class="results_top_description">
                    <p
                      v-html="
                        getrans(
                          get_lngdetails(item.lounge_id).lounge_description
                        )
                      "
                    ></p>
                  </div>
                </div>
              </div>
              <div class="results_top_price_button">
                <div class="results_top_price">
                  <span>{{ getrans("From") }} &nbsp;</span>
                  <span>
                    <b>
                      {{ currency }}
                      {{ item.from_display_price }}
                    </b></span
                  >
                </div>
                <div class="results_top_button">
                  <button
                    @click="
                      !expanding ? (expanded[i] = !expanded[i]) : false;
                      expanding = true;
                    "
                  >
                    <span v-if="!expanded[i]">{{ getrans("View") }}</span>
                    <span v-else
                      ><i class="fa fa-times" aria-hidden="true"></i>
                      {{ getrans("Close") }}</span
                    >
                  </button>
                </div>
              </div>
            </div>

            <!-- expansion area -->
            <slide-up-down
              v-model="expanded[i]"
              @close-end="expanding = false"
              @open-end="expanding = false"
              :duration="200"
              :responsive="true"
            >
              <div class="date_search">
                <b
                  >{{ getrans("You Searched for:") }}
                  <span class="search-dates">{{
                    this.results_subheadline
                  }}</span></b
                >
                <button
                  class="edit-search"
                  @click="
                    package_id_selected = item.calc[0].package_id;
                    expanded_widget[i] = !expanded_widget[i];
                    expanded_results[i] = !expanded_widget[i];
                  "
                >
                  Edit <i class="fas fa-edit"></i>
                </button>
              </div>

              <div v-show="expanded_widget[i]">
                <SearchWidget
                  :brand_slug="setbrandid"
                  brand_theme="light"
                  :custom_class="`large-strings no-background no-shadow`"
                  showTabs="lounge"
                  activeTab="lounge"
                  hideTabs="true"
                  :dateStart="date1_forwidget"
                  dateEnd=""
                  :lang="lang.toLowerCase()"
                  :venue_select="venue_select"
                  emit_search="true"
                  :adults_select="adults_select"
                  :children_select="children_select"
                  :infants_select="infants_select"
                  :senior_select="senior_select"
                  :loading_data="loading_data_widget ? 'true' : 'false'"
                  :hide_venue_select="`true`"
                  :button-text="`Update`"
                />
              </div>

              <div v-show="expanded_results[i]">
                <template v-for="(packages, n) in item.calc" :key="n">
                  <div class="results_expanded" :ref="`items-${i}`">
                    <!-- {{get_lngdetails(item.lounge_id)['lounge_image_' + lang]}} -->

                    <SlideShow
                      :images="
                        get_lngdetails(item.lounge_id)['lounge_image_' + lang]
                      "
                    ></SlideShow>

                    <!-- loop over the products here -->
                    <template v-for="(tickets, j) in packages.vtypes" :key="j">
                      <div class="results_expanded_wrapper">
                        <div class="results_expanded_title_description">
                          <div class="results_expanded_title">
                            <span
                              ><b>{{
                                getrans(tickets.visitor_type_name)
                              }}</b></span
                            >
                          </div>
                          <div
                            class="results_expanded_description"
                            v-html="
                              getrans(
                                get_visdetails(tickets.visitor_type_id)
                                  .description
                              )
                            "
                          ></div>
                        </div>
                        <div class="results_expanded_price_quantity">
                          <div class="results_expanded_price">
                            <!-- <span>{{ getrans("Tickets") }}:&nbsp;&nbsp;</span> -->
                            <span>
                              <span style="display: none">{{
                                tickets.system_visitor_type_name === "Adult"
                                  ? (item.from_display_price = parseFloat(
                                      tickets.rate
                                    ).toFixed(2))
                                  : ""
                              }}</span>

                              <b
                                :data-cust="tickets.system_visitor_type_name"
                                :data-price="
                                  parseFloat(tickets.rate).toFixed(2)
                                "
                                >{{ currency }}
                                {{ parseFloat(tickets.rate).toFixed(2) }}</b
                              ></span
                            >
                          </div>
                          <div class="results_expanded_quantity">
                            <div class="quantity-selector">
                              <!-- <button
                            @click="
                              [
                                $refs[`quantity-${i}-${j}`].value > 0
                                  ? $refs[`quantity-${i}-${j}`].value--
                                  : false,
                                set_sub_total(`items-${i}`, `subtotal-${i}`),
                              ]
                            "
                          >
                            <i class="fa fa-minus" aria-hidden="true"></i>
                          </button> -->

                              <!-- {{customers}}
                          {{getDropCount(tickets.system_visitor_type_name)}} -->

                              <select
                                name="quantity"
                                :ref="`quantity-${i}-${j}`"
                                :id="`quantity-${i}-${j}`"
                                :value="
                                  setDropCount(tickets.system_visitor_type_name)
                                "
                                @change="
                                  set_sub_total(
                                    `items-${i}`,
                                    `subtotal-${i}`,
                                    tickets.system_visitor_type_name
                                  )
                                "
                              >
                                <option
                                  v-if="
                                    tickets.system_visitor_type_name != 'Adult'
                                  "
                                  value="0"
                                >
                                  0
                                </option>
                                <template
                                  v-for="opt in getDropCount(
                                    tickets.system_visitor_type_name
                                  )"
                                  :key="opt"
                                >
                                  <option :value="opt">{{ opt }}</option>
                                </template>
                              </select>

                              <!-- cust {{cust}} -->
                              <!-- <button
                            @click="
                              [
                                $refs[`quantity-${i}-${j}`].value < 8
                                  ? $refs[`quantity-${i}-${j}`].value++
                                  : false,
                                set_sub_total(`items-${i}`, `subtotal-${i}`),
                              ]
                            "
                          >
                            <i class="fa fa-plus" aria-hidden="true"></i>
                          </button> -->
                            </div>
                          </div>
                        </div>
                      </div>
                    </template>

                    <!-- subtotal to add to basket -->
                    <div class="results_add">
                      <div class="results_add_subtotal">
                        <!-- needs to be calculated and update as quantity is changed 
                    and set back to 0 when add to basket clicked -->
                        <span>{{ getrans("Subtotal") }}:</span>&nbsp;&nbsp;

                        <!-- {{`subtotal-${i}`}} -->
                        <span
                          ><b
                            >{{ currency }}
                            <span :ref="`subtotal-${i}`">{{
                              item.grand_total
                            }}</span></b
                          ></span
                        >
                      </div>
                      <div class="results_add_button">
                        <button
                          :ref="`disabled-${i}`"
                          @click="
                            addtobasket(
                              packages.package_id,
                              item.lounge_id,
                              item.lounge_name
                            )
                          "
                        >
                          <i
                            v-if="add_to_basket_loader"
                            class="fas fa-circle-notch fa-spin"
                          ></i>
                          {{ getrans("Add to basket") }}
                        </button>
                      </div>
                    </div>
                  </div>
                </template>
              </div>
            </slide-up-down>
          </div>
        </template>
      </div>
    </div>

    <!-- <pre>
       {{ crosssell_data }} 
    </pre> -->
  </div>
</template>

<script>
const axios = require("axios");
const genkeys = require("rezauthlib");
var crypto = require('crypto');
const { v4: uuidv4 } = require("uuid");

import SearchWidget from "../components/SearchWidgetCustomElement.vue";
import SlideShow from "../components/SlideShow.vue";

/* eslint-disable */
import en from "date-format-parse/lib/locale/en";
import el from "date-format-parse/lib/locale/el";
import de from "date-format-parse/lib/locale/de";
import fr from "date-format-parse/lib/locale/fr";
import es from "date-format-parse/lib/locale/es";
import pt from "date-format-parse/lib/locale/pt";
/* eslint-enable */

import md5 from "js-md5";

const localforage = require("localforage");
let store = localforage.createInstance({
  name: "tranlations",
});

const { EncryptStorage } = require("encrypt-storage");
const encryptStorage = new EncryptStorage(process.env.VUE_APP_CHL, {
  storageType: "sessionStorage",
});

export default {
  name: "CrossSellResultsLNG",
  props: {
    crosssell_data_passed: undefined,
    num_of_crosssells: undefined,
  },
  components: {
    SearchWidget,
    SlideShow,
  },
  computed: {},
  data() {
    return {
      crosssell_data: "",
      refresh_widget: 0,
      update_lounge: 0,
      cross_sell_lounge_suggested: [],
      final_amount: 0,
      package_id_selected: "",
      buttonisActive: false,
      loading_data_widget: false,
      styles_loaded: false,
      currency: "",
      partner_id: "",
      partner_name: "",
      campaign_id: "",
      campaign_name: "",
      search_origin: "",
      expanding: false,
      booking_max_pax: 10,
      expanded: [],
      expanded_widget: [],
      expanded_results: [true],
      visitortypes: [],
      lang: "en",
      translations: "",
      discount_value: 0,
      brandSlug: "",
      date1_forwidget: "",
      date2_forwidget: "",
      date1_date: "2023/01/24",
      date1_time: "14:30",
      date2_date: "",
      date2_time: "",
      searchres: [],
      finalloungeresults: [],
      venue_select: "",
      venue_select_name: "",
      adults_select: "1",
      children_select: "0",
      infants_select: "0",
      senior_select: "",
      carparkdetails: [],
      dataloaded: false,
      setbrandid: "",
      dataloaded_carparkdetails: false,
      widgetloaded: false,
      css_data: undefined,
      results_headline: "Official Airport Lounge",
      results_subheadline: "",
      brand_data: undefined,
      brand_data_key: 0,
      brand_product_settings: {},
      brand_products: {},
      hero_desktop_background: "",
      hero_mobile_background: "",
      logo_image: "",
      hero_font_size_h1: "1.5rem",
      hero_font_size_h1_mobile: "1.3rem",
      hero_font_size_p: "1.3rem",
      hero_font_size_p_mobile: "1rem",
      hero_text_align: "center",
      hero_text_align_mobile: undefined,
      use_local_data: false,
      header_menu: [],
      footer_links: [],
      logo_link: { mtype: "Internal", url: "/" },
      home_link: undefined,
      panels_background_color: "#d6d6d6",
      panels_group: undefined,
      panel_columns: 1,
      footer_columns: "1 Columns",
      show_basket: false,
      result_selected_style: "list",
      result_selected_order: "closest",
      showSearchWidget: false,
      noSlotsAvailable: false,
      neworder: false,
      neworder_key: 0,
      closeest_cheapest: "closest",
      booking_applicable: "",
      loungesubtotal: 0,
      actcustomers: [],
      customers: [],
      actcustomerprices: [],
      searchres_filtered: {},
      add_to_basket_loader: false,
      product_descriptions: false,
      brandloaded: false,
      manual_search: false,
    };
  },
  methods: {
    gensessionid() {
      if (encryptStorage.getItem("search_analytics_id") === undefined) {
        let search_analytics_id = crypto.randomBytes(16).toString("base64");
        encryptStorage.setItem("search_analytics_id", search_analytics_id);
        return search_analytics_id;
      } else {
        return encryptStorage.getItem("search_analytics_id");
      }
    },
    getDropCount(type) {
      let count = 0;
      /* eslint-disable */
      for (const [key, val] of Object.entries(this.customers)) {
        if (val.ctype == type) {
          count = val.drop_count;
        }
      }
      /* eslint-enable */
      return count;
    },

    setDropCount(type) {
      let count = 0;
      /* eslint-disable */
      for (const [key, val] of Object.entries(this.customers)) {
        if (val.ctype == type) {
          count = val.count;
        }
      }
      /* eslint-enable */
      return count;
    },

    check_zero_subtotal(i) {
      let results_add = this.$refs[`subtotal-section-${i}`];
      let subtotal_el = this.$refs[`subtotal-${i}`];
      if (results_add && subtotal_el) {
        if (subtotal_el.innerHTML === "0.00") {
          this.disable_add_to_basket = true;
          //results_add.style.display = "none";
        } else {
          this.disable_add_to_basket = false;
          //results_add.style.display = "flex";
        }
      }
    },

    validate_data() {
      var adl = 0;
      var chi = 0;
      var inf = 0;
      for (let key in this.actcustomers) {
        let q = Number(this.actcustomers[key]);
        if (key == "Adult") {
          adl = q;
        }
        if (key == "Child") {
          chi = q;
        }
        if (key == "Infant") {
          inf = q;
        }
      }
      for (var y = 0; y < this.customers.length; y++) {
        if (this.customers[y].ctype == "Adult") {
          if (Number(adl) + Number(chi) + Number(inf) > this.booking_max_pax) {
            adl = this.booking_max_pax - (Number(chi) + Number(inf));
          }
          let adult_count = this.booking_max_pax - (Number(chi) + Number(inf));
          this.customers[y].count = adl;
          this.customers[y].drop_count = adult_count;
        }
        if (this.customers[y].ctype == "Child") {
          if (Number(adl) + Number(chi) + Number(inf) > this.booking_max_pax) {
            chi = this.booking_max_pax - (Number(adl) + Number(inf));
          }
          let adult_count = this.booking_max_pax - (Number(adl) + Number(inf));
          this.customers[y].count = chi;
          this.customers[y].drop_count = adult_count;
        }
        if (this.customers[y].ctype == "Infant") {
          if (Number(adl) + Number(chi) + Number(inf) > this.booking_max_pax) {
            inf = this.booking_max_pax - (Number(chi) + Number(adl));
          }
          let adult_count = this.booking_max_pax - (Number(chi) + Number(adl));
          this.customers[y].count = inf;
          this.customers[y].drop_count = adult_count;
        }
      }
    },

    set_sub_total(item, subtotal_el, custtype) {
      //console.log("subtotal_el_item_aa", item);
      //console.log("subtotal_cust.ctype", custtype);
      //console.log("actcustomers", this.actcustomers);

      if (this.$refs[item] && this.$refs[subtotal_el]) {
        let price_and_quantity = [
          ...this.$refs[item].querySelectorAll(
            ".results_expanded_price_quantity"
          ),
        ];
        let subtotal = [];
        price_and_quantity.map((el) => {
          let price = el
            .querySelector("[data-price]")
            .getAttribute("data-price");
          let cust = el.querySelector("[data-cust]").getAttribute("data-cust");
          let quantity = el.querySelector("select").value;
          subtotal.push({ price, quantity, cust });
        });
        let subtotal_display = "0.00";
        subtotal.map((val) => {
          this.actcustomers[val.cust] = val.quantity;
          this.actcustomerprices[val.cust] = val.price;
          subtotal_display =
            Number(
              Number(subtotal_display) +
                Number(val.price) * Number(val.quantity)
            ).toFixed(2) + "";
        });
        this.$refs[subtotal_el].innerHTML = subtotal_display;
        if (this.final_amount > 0) {
          this.loungesubtotal = this.final_amount;
        } else {
          this.loungesubtotal = subtotal_display;
        }

        let disabled_el = subtotal_el.replace("subtotal-", "disabled-");

        if (subtotal_display === "0.00") {
          this.$refs[disabled_el].disabled = true;
        } else {
          this.$refs[disabled_el].disabled = false;
        }
      }
      this.validate_data(item, subtotal_el, custtype);
      //console.log("set_sub_total item", item);
      this.check_zero_subtotal(item);
    },

    getrans(string) {
      var s = md5(string);
      var ss = this.brandSlug + "-" + this.lang.toUpperCase() + "-" + s;
      //console.log("getrans", string, ss, this.translations[ss]);
      return this.translations[ss] || string;
    },
    getSessionData(name) {
      return JSON.parse(sessionStorage.getItem(name));
    },
    setSessionData(name, value) {
      if (value != null) sessionStorage.setItem(name, JSON.stringify(value));
      else sessionStorage.removeItem(name);
    },
    loadTranslations() {
      let vm = this;
      if (vm.getSessionData("language")) {
        vm.lang = vm.getSessionData("language");
      } else {
        vm.setSessionData("language", vm.lang);
      }

      const urlParams = new URLSearchParams(window.location.search);
      let param_lang = urlParams.get("lang");
      if (param_lang) {
        vm.lang = param_lang;
        vm.setSessionData("language", vm.lang);
      }

      store.getItem("tranlations").then((params) => {
        if (params !== null) {
          vm.translations = JSON.parse(params);
          vm.set_results_subheadline();
        } else {
          axios
            .get(
              "https://devhub.rezcomm.com/hubapmydbauth/brandapi/devtrans.php?brandslug=" +
                vm.setbrandid
            )
            .then((response) => {
              vm.translations = JSON.parse(response.request.response);
              store.setItem("tranlations", JSON.stringify(vm.translations));
              vm.set_results_subheadline();
            });
        }
      });
    },

    put(key, value, obj) {
      obj[key] = value;
      return obj;
    },
    setListStyle(type) {
      this.result_selected_style = type;
    },

    sortByDistancePrice() {
      /* eslint-disable */
      this.searchres_filtered = {};
      for (let j = 0; j < this.searchres.length; j++) {
        for (let i = 0; i < this.neworder.length; i++) {
          if (
            this.searchres[j].carpark_id &&
            this.searchres[j].carpark_id === this.neworder[i]
          ) {
            this.searchres_filtered[i] = this.searchres[j];
          }
        }
      }
      /* eslint-enable */
    },

    setListOrder(type) {
      if (!this.carparkdetails && !this.carparkdetails.clients) {
        return false;
      }
      if (
        this.carparkdetails.clients === "null" ||
        this.carparkdetails.clients === undefined
      ) {
        return null;
      }

      if (type === "closest") {
        this.closeest_cheapest = "closest";
        this.result_selected_order = type;
        let obj = Object.values(this.carparkdetails.clients);
        let neworder = obj.sort(function (a, b) {
          if (b.distance_order) {
            return a.distance_order - b.distance_order;
          }
        });
        let newobj = [];
        for (let i = 0; i < neworder.length; i++) {
          newobj.push(neworder[i].carpark_id);
        }
        this.neworder = newobj;
        this.neworder_key++;
      }

      if (type === "cheapest") {
        this.closeest_cheapest = "cheapest";

        this.result_selected_order = type;
        let obj = Object.values(this.searchres);

        let neworder = obj.sort(function (a, b) {
          if (b.grand_total) {
            return a.grand_total - b.grand_total;
          }
        });
        let newobj = [];
        for (let i = 0; i < neworder.length; i++) {
          newobj.push(neworder[i].carpark_id);
        }
        this.neworder = newobj;
        this.neworder_key++;
      }

      this.sortByDistancePrice();
    },
    getLocalData(name) {
      return JSON.parse(sessionStorage.getItem(name));
    },
    setLocalData(name, value) {
      if (value != null) sessionStorage.setItem(name, JSON.stringify(value));
      else sessionStorage.removeItem(name);
    },
    setBrandData() {
      this.brand_data = this.getLocalData("brand_data");
      this.brand_product_settings = this.brand_data.brand_product_settings;
      this.brand_products = this.brand_data.brand_products;
      this.brand_data_key++;
      this.styles_loaded = true;
    },
    genuuid() {
      if (sessionStorage.getItem("uuid") === null) {
        let uuidgen = uuidv4();
        this.setLocalData("uuid", uuidgen);
        return sessionStorage.getItem("uuid");
      } else {
        return sessionStorage.getItem("uuid").replaceAll('"', "");
      }
    },
    getBrandData() {
      if (this.use_local_data && this.getLocalData("brand_data")) {
        this.setBrandData();
      } else {
        let secsa = genkeys(
          encryptStorage.getItem("rez_dev_k").VUE_APP_BRNDDET_SECRETID,
          encryptStorage.getItem("rez_dev_k").VUE_APP_BRNDDET_SECRETKEY
        );
        let b1s = secsa.b1s;
        let v2s = secsa.v2s;
        let a1 = secsa.a1;
        let v1 = secsa.v1;
        let c2s = secsa.c2s;
        let uidgen = secsa.uidgen;

        axios
          .post(
            encryptStorage.getItem("rez_dev_k").VUE_APP_DOMAIN_DEVHUB +
              "hubapmydbauth/brandapi/branddetailslive.php?brandslug=" +
              this.brandSlug,
            "",
            {
              headers: {
                b1: b1s,
                v2: v2s,
                c2s: c2s,
                a1: a1,
                v1: v1,
                c1: uidgen,
                "Content-Type": "application/json",
              },
            }
          )
          .then((response) => {
            this.setLocalData("brand_data", response.data);
            this.setBrandData();
          });
      }
    },
    getDescriptions() {
      let secsa = genkeys(
        encryptStorage.getItem("rez_dev_k").VUE_APP_BRNDDET_SECRETID,
        encryptStorage.getItem("rez_dev_k").VUE_APP_BRNDDET_SECRETKEY
      );
      let b1s = secsa.b1s;
      let v2s = secsa.v2s;
      let a1 = secsa.a1;
      let v1 = secsa.v1;
      let c2s = secsa.c2s;
      let uidgen = secsa.uidgen;

      let data = {
        brand_id: this.brandSlug,
      };

      axios
        .post(
          encryptStorage.getItem("rez_dev_k").VUE_APP_DOMAIN_DEVHUB +
            "hubapmydbauth/lounge/loungedetailslive.php",
          data,
          {
            headers: {
              b1: b1s,
              v2: v2s,
              c2s: c2s,
              a1: a1,
              v1: v1,
              c1: uidgen,
              "Content-Type": "application/json",
            },
          }
        )
        .then((response) => {
          setTimeout(() => {
            if (this.crosssell_data.data) {
              this.set_sub_total("items-0", "subtotal-0", "ADL");
            } else {
              this.set_sub_total("items-0", "subtotal-0", "ADL");
              this.set_sub_total("items-0", "subtotal-0", "CHD");
              this.set_sub_total("items-0", "subtotal-0", "INF");
            }
            this.check_zero_subtotal("0");
          }, 0);
          this.product_descriptions = response.data.clients;
          this.set_lngcrossell_shown();          
          this.dataloaded = true;
          this.$emit("loading_results_finished", "true");
          setTimeout(() => {
            // setTimeout(() => {
            //   this.expanded[0] = true;
            // }, 1000);
            // if (this.num_of_crosssells > 1) {
            //   this.expanded[0] = false;
            // }

            if (this.manual_search) {
              this.expanded[0] = true;
            }
            this.loading_data_widget = false;
            this.expanded_widget[0] = false;
            this.expanded_results[0] = true;

            //this.expanded[0] = true;
          }, 1);
        });
    },

    get_visdetails(visitor_type_id) {
      //console.log("get_visdetails", visitor_type_id);
      let lng_return_data = {};
      /* eslint-disable */
      for (const [key, val] of Object.entries(this.product_descriptions)) {
        if (key === "visdetails") {
          for (const [lng_key, lng_val] of Object.entries(val)) {
            if (
              lng_val.visitor_type_id.toString() === visitor_type_id.toString()
            ) {
              lng_return_data = lng_val;
            }
          }
        }
      }
      /* eslint-enable */
      return lng_return_data;
    },

    get_lngdetails(lounge_id) {
      //console.log("get_lngdetails", lounge_id);
      let lng_return_data = {};
      if (!this.product_descriptions) {
        return "";
      }
      /* eslint-disable */
      for (const [key, val] of Object.entries(this.product_descriptions)) {
        if (key === "lngdetails") {
          for (const [lng_key, lng_val] of Object.entries(val)) {
            if (lng_val.lounge_id.toString() === lounge_id.toString()) {
              lng_return_data = lng_val;
            }
          }
        }
      }
      /* eslint-enable */
      return lng_return_data;
    },

    getvisitortypes() {
      let dataa = {
        requireTotalCount: true,
        searchOperation: "contains",
        searchValue: null,
        skip: 0,
        take: 25,
        userData: {},
        sort: null,
        group: null,
        totalSummary: [{ summaryType: "count" }],
        query: {},
        ascending: 1,
        byColumn: 1,
        page: 1,
        limit: 25,
        brand_id: this.brandSlug,
      };
      axios
        .post(
          encryptStorage.getItem("rez_dev_k").VUE_APP_DOMAIN_LIVESSO +
            "lounge/backend/visitor_type/list",
          dataa,
          {
            headers: {
              secret_id: "ffda61dc9d474d6575d5bc26915aea64",
              secret_key:
                "e299ed60ce833168490712a6cd9c7c1a0c20eec766fced527520118f586cd156",
              "Content-Type": "application/json",
            },
          }
        )
        .then((response) => {
          //console.log(response);
          let vs = JSON.parse(response.request.response);
          this.visitortypes = vs.data;
          this.getApiData_lounge();
        });
    },
    setMenu(data) {
      data.brand_menu.forEach((menu) => {
        if (menu.label.toLowerCase() === "home") {
          this.home_link = menu.url;
        }
        if (menu.label.toLowerCase() === "logo") {
          this.logo_link = menu;
        }
        menu.loggedin = true;
        menu.loggedout = true;
      });

      const top_menu = data.brand_menu.filter((menu) => menu.position === "T");
      this.createHeaderLinks(top_menu);

      const footer_menu = data.brand_menu.filter(
        (menu) => menu.position === "B"
      );
      this.createFooterLinks(footer_menu);
    },
    createHeaderLinks(data) {
      const header_menu = [];
      if (data.length > 0) {
        data.forEach((menu) => {
          if (menu.label.toLowerCase() === "basket") {
            this.show_basket = true;
          } else if (
            menu.label.toLowerCase() !== "home" &&
            menu.label.toLowerCase() !== "logo"
          ) {
            header_menu.push(menu);
          }
        });
      }
      this.header_menu = header_menu;
    },
    createFooterLinks(data) {
      this.footer_columns = data[0].mcolumn;
      this.footer_links = data.reduce((a, r) => {
        if (!a[r.mgroup]) a[r.mgroup] = { group: r.mgroup, data: [] };
        a[r.mgroup].data.push(r);
        return a;
      }, {});
    },
    createPanels(data) {
      let panels_data = data.brand_home_panels || [];
      panels_data.sort((a, b) => (a.rownum > b.rownum ? 1 : -1));
      panels_data = panels_data.reduce((a, r) => {
        if (!a[r.rownum]) a[r.rownum] = { row: r.rownum, columns: [] };
        a[r.rownum].columns.push(r);
        return a;
      }, {});
      this.panels_group = panels_data;
    },
    correctdate(d) {
      if (d) {
        d = d.replace("st", "");
        d = d.replace("nd", "");
        d = d.replace("rd", "");
        d = d.replace("th", "");
        return d;
      }
    },
    formatDateymd(date) {
      var d = new Date(date),
        month = "" + (d.getMonth() + 1),
        day = "" + d.getDate(),
        year = d.getFullYear();
      if (month.length < 2) month = "0" + month;
      if (day.length < 2) day = "0" + day;
      return [year, month, day].join("/");
    },
    format_date(date, format_date) {
      const pad = (n, s = 2) => `${new Array(s).fill(0)}${n}`.slice(-s);
      if (date) {
        let dt = new Date(date);
        //let months = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];
        let months = [
          "Jan",
          "Feb",
          "Mar",
          "Apr",
          "May",
          "Jun",
          "Jul",
          "Aug",
          "Sep",
          "Oct",
          "Nov",
          "Dec",
        ];
        let month = months[dt.getMonth()];
        let day =
          dt.getDate() +
          (dt.getDate() % 10 == 1 && dt.getDate() != 11
            ? "st"
            : dt.getDate() % 10 == 2 && dt.getDate() != 12
            ? "nd"
            : dt.getDate() % 10 == 3 && dt.getDate() != 13
            ? "rd"
            : "th");

        let hours = dt.getHours();
        let mins = dt.getMinutes();
        let year = dt.getFullYear();
        let dateString = "";
        if (format_date === "date") {
          dateString = `${month} ${day} ${year}`;
        }
        if (format_date === "time") {
          dateString = `${pad(hours)}:${pad(mins)}`;
        }
        return dateString;
      }
    },

    format_date_with_locale(date, format_date) {
      const pad = (n, s = 2) => `${new Array(s).fill(0)}${n}`.slice(-s);
      if (date) {
        let language;
        let digits = 2;
        if (this.lang === "en") {
          language = en;
        }
        if (this.lang === "el") {
          language = el;
        }
        if (this.lang === "de") {
          language = de;
        }
        if (this.lang === "fr") {
          language = fr;
        }
        if (this.lang === "es") {
          language = es;
          digits = 3;
        }
        if (this.lang === "pt") {
          language = pt;
          digits = 3;
        }
        let lang_obj;
        if (digits === 2) {
          lang_obj = {
            formatLocale: language,
            yearFormat: "YYYY",
            monthFormat: "MMM",
            monthBeforeYear: true,
          };
        } else if (digits === 3) {
          lang_obj = {
            formatLocale: language,
            yearFormat: "YYYY",
            monthFormat: "MMM",
            days: language.weekdaysShort,
            monthBeforeYear: true,
          };
        }
        let months = lang_obj.formatLocale.monthsShort;

        let dt = new Date(date);

        let month = months[dt.getMonth()];
        let day = dt.getDate() + "";

        if (this.lang === "en") {
          day =
            dt.getDate() +
            (dt.getDate() % 10 == 1 && dt.getDate() != 11
              ? "st"
              : dt.getDate() % 10 == 2 && dt.getDate() != 12
              ? "nd"
              : dt.getDate() % 10 == 3 && dt.getDate() != 13
              ? "rd"
              : "th");
        }

        let hours = dt.getHours();
        let mins = dt.getMinutes();
        let year = dt.getFullYear();
        let dateString = "";
        if (format_date === "date") {
          dateString = `${month} ${day} ${year}`;
        }
        if (format_date === "time") {
          dateString = `${pad(hours)}:${pad(mins)}`;
        }
        return dateString;
      }
    },
    inArray(needle, haystack) {
      var length = haystack.length;
      for (var i = 0; i < length; i++) {
        if (haystack[i] == needle) return true;
      }
      return false;
    },
    getApiData_lounge() {
      let vis = [];
      let cvis = 0;
      let avis = 0;
      let ivis = 0;
      for (let a = 0; a < this.visitortypes.length; a++) {
        let visitem = this.visitortypes[a];
        if (visitem.system_visitor_type_id.toString() == "2") {
          cvis = visitem.visitor_type_id;
        }
        if (visitem.system_visitor_type_id.toString() == "3") {
          avis = visitem.visitor_type_id;
        }
        if (visitem.system_visitor_type_id.toString() == "1") {
          ivis = visitem.visitor_type_id;
        }
      }
      if (parseInt(this.adults_select) > 0) {
        let it = {};
        it.visitor_type_id = avis;
        it.count = this.adults_select;
        vis.push(it);
      }
      if (parseInt(this.children_select) > 0) {
        let ita = {};
        ita.visitor_type_id = cvis;
        ita.count = this.children_select;
        vis.push(ita);
      }
      if (parseInt(this.infants_select) > 0) {
        let iti = {};
        iti.visitor_type_id = ivis;
        iti.count = this.infants_select;
        vis.push(iti);
      }

      let search_origin = this.search_origin || window.location.hostname;

      let data = {
        brand_id: this.brandSlug,
        venue_id: this.venue_select,
        valid_from: this.date1_date,
        start_time: this.date1_time,
        visitors: vis,
        tracking_id: this.gensessionid(),
        partner_id: this.partner_id,
        partner_name: this.partner_name,
        campaign_id: this.campaign_id,
        campaign_name: this.campaign_name,
        search_origin: search_origin,
        venue_name: this.venue_select_name,
        crossell:"1",
      };
      console.log("crosll sell request", data);
      let secsa = genkeys(
        encryptStorage.getItem("rez_dev_k").VUE_APP_LOUNGE_SEARCH_SECRETID,
        encryptStorage.getItem("rez_dev_k").VUE_APP_LOUNGE_SEARCH_SECRETKEY
      );
      let b1s = secsa.b1s;
      let v2s = secsa.v2s;
      let a1 = secsa.a1;
      let v1 = secsa.v1;
      let c2s = secsa.c2s;
      let uidgen = secsa.uidgen;
      axios
        .post(
          encryptStorage.getItem("rez_dev_k").VUE_APP_DOMAIN_LIVESSO + "lounge/frontend/package/search",
          data,
          {
            headers: {
              b1: b1s,
              v2: v2s,
              c2s: c2s,
              a1: a1,
              v1: v1,
              c1: uidgen,
              "Content-Type": "application/json",
            },
          }
        )
        .then(
          (response) => {
            let datasent = JSON.parse(response.request.response);

            this.searchres = datasent.data;

            if (this.searchres === "No Slots Available") {
              this.noSlotsAvailable = true;
            }
            let results = [];
            for (let a = 0; a < this.searchres.length; a++) {
              let item = this.searchres[a];
              if (item.booking_applicable == "Y") {
                if (
                  this.inArray(item.lounge_id, this.cross_sell_lounge_suggested)
                ) {
                  let it = {};
                  it.lounge_id = item.lounge_id;
                  it.lounge_name = item.lounge_name;
                  it.total_amount = item.total_amount;

                  if (this.final_amount > 0) {
                    this.loungesubtotal = parseFloat(this.final_amount);
                    it.grand_total = parseFloat(this.final_amount);
                  } else {
                    this.loungesubtotal = parseFloat(this.grand_total);
                    it.grand_total = item.grand_total;
                  }
                  it.total_discount = item.total_discount;
                  it.total_discount = item.total_discount;
                  let calculations = item.calculations;
                  let calc = [];
                  for (let b = 0; b < calculations.length; b++) {
                    let citem = calculations[b];
                    let cit = {};
                    cit.package_id = citem.package_id;
                    cit.package_name = citem.package_name;
                    let visitor_types = citem.visitor_types;
                    let vtypes = [];
                    for (let c = 0; c < visitor_types.length; c++) {
                      let vist = visitor_types[c];
                      let vit = {};
                      if (this.crosssell_data.data) {
                        if (
                          vist.system_visitor_type_name == "Adult" ||
                          vist.system_visitor_type_name == "Child" ||
                          (this.infants_select &&
                            vist.system_visitor_type_name == "Infant")
                        ) {
                          vit.system_visitor_type_name =
                            vist.system_visitor_type_name;
                          vit.visitor_type_id = vist.visitor_type_id;
                          vit.visitor_type_name = vist.visitor_type_name;
                          vit.count = vist.count;
                          let r = parseFloat(vist.rate);
                          let d = (this.discount_value * r) / 100;
                          let rt = (r - d).toFixed(2);
                          vit.rate = rt;
                          vtypes.push(vit);
                        }
                      } else {
                        vit.system_visitor_type_name =
                          vist.system_visitor_type_name;
                        vit.visitor_type_id = vist.visitor_type_id;
                        vit.visitor_type_name = vist.visitor_type_name;
                        vit.count = vist.count;
                        vit.rate = vist.rate;
                        vtypes.push(vit);
                      }
                    }
                    cit.vtypes = vtypes;
                    calc.push(cit);
                  }
                  it.calc = calc;
                  results.push(it);
                }
              }
            }
            this.finalloungeresults = results;

            console.log("this.finalloungeresults", this.finalloungeresults);

            this.getDescriptions();
          },
          (error) => {
            console.log("searchres error", error);
          }
        );

      setTimeout(() => {
        this.widgetloaded = true;
        //sessionStorage.clear();
      }, 0);
    },

    set_results_quantitys() {
      if (this.date1_date && this.date1_time) {
        this.customers = [];
        let it = {};

        if (this.adults_select) {
          let adult_string = "";
          if (Number(this.adults_select) > 1) {
            adult_string = "Adults";
          } else if (Number(this.adults_select) === 1) {
            adult_string = "Adult";
          }

          if (
            Number(this.adults_select) +
              Number(this.children_select) +
              Number(this.infants_select) >
            this.booking_max_pax
          ) {
            this.adults_select =
              this.booking_max_pax -
              (Number(this.children_select) + Number(this.infants_select));
          }
          let adult_count =
            this.booking_max_pax -
            (Number(this.children_select) + Number(this.infants_select));
          it = {
            ctype: "Adult",
            count: Number(this.adults_select),
            display: adult_string,
            drop_count: adult_count,
          };
          this.customers.push(it);
        }

        if (this.children_select) {
          let children_string = "";
          if (Number(this.children_select) > 1) {
            children_string = "Children";
          } else if (Number(this.children_select) === 1) {
            children_string = "Child";
          }

          if (
            Number(this.adults_select) +
              Number(this.children_select) +
              Number(this.infants_select) >
            this.booking_max_pax
          ) {
            this.children_select =
              this.booking_max_pax -
              (Number(this.adults_select) + Number(this.infants_select));
          }
          let adult_count =
            this.booking_max_pax -
            (Number(this.adults_select) + Number(this.infants_select));
          it = {
            ctype: "Child",
            count: 0,
            display: children_string,
            drop_count: adult_count,
          };
          this.customers.push(it);
        }

        if (this.infants_select) {
          let infants_string = "";
          if (Number(this.infants_select) > 1) {
            infants_string = "Infants";
          } else if (Number(this.infants_select) === 1) {
            infants_string = "Infant";
          }

          if (
            Number(this.adults_select) +
              Number(this.children_select) +
              Number(this.infants_select) >
            this.booking_max_pax
          ) {
            this.infants_select =
              this.booking_max_pax -
              (Number(this.children_select) + Number(this.adults_select));
          }
          let adult_count =
            this.booking_max_pax -
            (Number(this.children_select) + Number(this.adults_select));
          it = {
            ctype: "Infant",
            count: Number(this.infants_select),
            display: infants_string,
            drop_count: adult_count,
          };
          this.customers.push(it);
        }

        // if (this.senior_select) {
        //   let senior_string = "";
        //   if (Number(this.senior_select) > 1) {
        //     senior_string = this.getrans("Seniors");
        //     this.results_subheadline +=
        //       ", " + this.senior_select + " " + senior_string;
        //   } else if (Number(this.senior_select) === 1) {
        //     senior_string = this.getrans("Senior");
        //     this.results_subheadline +=
        //       ", " + this.senior_select + " " + senior_string;
        //   }
        // }
      }
    },
    gotoPage(url) {
      window.location.href = url;
    },
    crosssellcheck() {
      let vis = [];
      let cvis = 0;
      let avis = 0;
      let ivis = 0;
      for (let a = 0; a < this.visitortypes.length; a++) {
        let visitem = this.visitortypes[a];
        if (visitem.system_visitor_type_id.toString() == "2") {
          cvis = visitem.visitor_type_id;
        }
        if (visitem.system_visitor_type_id.toString() == "3") {
          avis = visitem.visitor_type_id;
        }
        if (visitem.system_visitor_type_id.toString() == "1") {
          ivis = visitem.visitor_type_id;
        }
      }
      if (parseInt(this.adults_select) > 0) {
        let it = {};
        it.visitor_type_id = avis;
        it.count = this.adults_select;
        vis.push(it);
      }
      if (parseInt(this.children_select) > 0) {
        let ita = {};
        ita.visitor_type_id = cvis;
        ita.count = this.children_select;
        vis.push(ita);
      }
      if (parseInt(this.infants_select) > 0) {
        let iti = {};
        iti.visitor_type_id = ivis;
        iti.count = this.infants_select;
        vis.push(iti);
      }

      let secsa = genkeys(
        encryptStorage.getItem("rez_dev_k").VUE_APP_CSLCHK_SECRETID,
        encryptStorage.getItem("rez_dev_k").VUE_APP_CSLCHK_SECRETKEY
      );
      let datacsl = encryptStorage.getItem("datacsl");
      datacsl.lounge = {
        visitors: vis,
        custom_search: "Y",
        venue_id: this.venue_select,
        package_id: this.package_id_selected,
        entry_date: this.date1_date,
        start_time: this.date1_time,
      };
      datacsl.fasttrack = { guid: this.genuuid() };
      let b1s = secsa.b1s;
      let v2s = secsa.v2s;
      let a1 = secsa.a1;
      let v1 = secsa.v1;
      let c2s = secsa.c2s;
      let uidgen = secsa.uidgen;
      axios
        .post(
          encryptStorage.getItem("rez_dev_k").VUE_APP_DOMAIN_LIVESSO +
            "cross_sell/frontend/availability/view",
          datacsl,
          {
            headers: {
              b1: b1s,
              v2: v2s,
              c2s: c2s,
              a1: a1,
              v1: v1,
              c1: uidgen,
              "Content-Type": "application/json",
            },
          }
        )
        .then((response) => {
          //Swal.close();

          this.expanded[0] = false;

          console.log("response", response);

          let datasent = JSON.parse(response.request.response);
          let user_exists = datasent.user_exists;

          if (user_exists == "N") {
            console.log('user_exists == "N"');
            this.noSlotsAvailable = true;
            this.loading_data_widget = false;
            this.finalloungeresults = [];
          }

          if (user_exists == "Y") {
            encryptStorage.setItem("crosssell_shown", "Yes");
            encryptStorage.setItem("crosssell_data", datasent);
            console.log("crosssell_data", datasent);
            encryptStorage.setItem("curr_search_results", this.searchres);
            // this.gotoPage("/crosssell.html");
            this.cross_sell_lounge_suggested = [];
            this.crosssell_data = datasent;
            if (this.crosssell_data.data) {
              this.crosssell_data.data.forEach((item) => {
                if (item.suggestion_product_id === "lng") {
                  console.log("item lng", item);

                  if (item.status === "Error") {
                    console.log("no slots");
                  } else {
                    this.discount_value = parseFloat(item.discount_value);
                    let lounge_id_suggested = item.api_data[0].lounge_id;
                    this.visitortypes =
                      item.api_data[0].calculations[0].visitor_types;
                    this.cross_sell_lounge_suggested.push(lounge_id_suggested);
                    this.final_amount = parseFloat(item.final_amount);
                    let lngshown = {"product_id":"LNG","amount":this.final_amount,"lounge_name":item.sub_product_name};
                    console.log('crosssell_lngshown',lngshown);
                    encryptStorage.setItem("crosssell_lngshown",lngshown);                    
                    console.log("lounge_id_suggested", lounge_id_suggested);
                    console.log("this.final_amount", this.final_amount);
                    // this.date1_date = item.valid_from.replaceAll("-", "/");
                    // this.date1_time = item.start_time;

                    this.date1_forwidget =
                      this.date1_date + " " + this.date1_time;
                    for (let a = 0; a < this.visitortypes.length; a++) {
                      let an = this.visitortypes[a];
                      if (an.system_visitor_type_name == "Adult") {
                        this.adults_select = an.count;
                      }
                      if (an.system_visitor_type_name == "Child") {
                        this.children_select = an.count;
                      }
                      if (an.system_visitor_type_name == "Infant") {
                        this.infants_select = an.count;
                      }
                    }
                  }
                  this.refresh_widget++;
                }
              });
              console.log(
                "this.cross_sell_lounge_suggested",
                this.cross_sell_lounge_suggested
              );
            }
            this.getbranded();
          } else {
            //encryptStorage.setItem("crosssell_shown", "No");
            //this.gotoPage("/yourdetails.html");
          }
        });
    },
    set_lngcrossell_shown()
    {
      this.crosssell_data.data.forEach((item) => {
        console.log('item cross',item);
        if (item.suggestion_product_id === "lng") {
          this.final_amount = parseFloat(item.final_amount);
          let lngshown = {"product_id":"LNG","amount":this.final_amount,"lounge_name":item.sub_product_name};
          console.log('crosssell_lngshown',lngshown);
          encryptStorage.setItem("crosssell_lngshown",lngshown);
        }
      });      
    } ,      
    getbranded() {
      //var thingy = this;
      axios
        .post(
          encryptStorage.getItem("rez_dev_k").VUE_APP_DOMAIN_DEVHUB +
            "hubapmydbauth/brandapi/getbrnslg_dev.php",
          "",
          {
            headers: {
              secret_id: encryptStorage.getItem("rez_dev_k").VUE_APP_BRNDED_SECRETID,
              secret_key: encryptStorage.getItem("rez_dev_k").VUE_APP_BRNDED_SECRETKEY,
              "Content-Type": "application/json",
            },
          }
        )
        .then((response) => {
          //console.log(response.data.slug);
          //console.log(response.data.currency);
          if (response.data.code == "1") {
            this.setbrandid = response.data.slug;
            this.brandSlug = response.data.slug;
            this.currency = response.data.currency;
            if (response.data.slug == "HER" || response.data.slug == "NOC" || response.data.slug == "SZG") {
              this.currency = "€";
            }

            this.loadTranslations();
            this.getBrandData();
            this.getvisitortypes();
            this.brandloaded = true;
            this.widgetloaded = true;
          }
        });
    },
    lounge_unreserve() {
      if (typeof encryptStorage.getItem("lounge_cart") !== "undefined") {
        let data = {
          booking_ref_id: encryptStorage.getItem("lounge_cart").lng_order_ref,
          brand_id: this.setbrandid,
        };
        let secsaa = genkeys(
          encryptStorage.getItem("rez_dev_k").VUE_APP_LOUNGE_UNRS_SECRETID,
          encryptStorage.getItem("rez_dev_k").VUE_APP_LOUNGE_UNRS_SECRETKEY
        );
        let b1sa = secsaa.b1s;
        let v2sa = secsaa.v2s;
        let a1a = secsaa.a1;
        let v1a = secsaa.v1;
        let c2sa = secsaa.c2s;
        let uidgena = secsaa.uidgen;
        axios
          .post(encryptStorage.getItem("rez_dev_k").VUE_APP_LOUNGEUNRESERVE_URL, data, {
            headers: {
              b1: b1sa,
              v2: v2sa,
              c2s: c2sa,
              a1: a1a,
              v1: v1a,
              c1: uidgena,
            },
          })
          .then((response) => {
            let datasent = JSON.parse(response.request.response);
            console.log("datasent", datasent);
          });
      }
    },
    addtobasket(package_id, lounge_id, product_name) {
      this.lounge_unreserve();
      this.add_to_basket_loader = true;
      encryptStorage.setItem("product_name", product_name);
      let guid = this.genuuid();
      let fincust = this.actcustomers;
      let fincustprices = this.actcustomerprices;
      this.setLocalData("venue_selected_lng", this.venue_select);
      this.setLocalData("venue_selected_name_lng", this.venue_select_name);
      let dispdate = this.date1_date.split("/");
      let date_selected_display =
        dispdate[2] + "/" + dispdate[1] + "/" + dispdate[0];

      var pax = [];
      let cvis = 0;
      let avis = 0;
      let ivis = 0;
      for (let a = 0; a < this.visitortypes.length; a++) {
        let visitem = this.visitortypes[a];
        if (visitem.system_visitor_type_id.toString() == "2") {
          cvis = visitem.visitor_type_id;
        }
        if (visitem.system_visitor_type_id.toString() == "3") {
          avis = visitem.visitor_type_id;
        }
        if (visitem.system_visitor_type_id.toString() == "1") {
          ivis = visitem.visitor_type_id;
        }
      }
      let lngtot = 0;
      for (let key in this.actcustomers) {
        // var q = 0;

        //q = Number(this.actcustomers[key]);
        if (key == "Adult") {
          let it = {};
          it.visitor_type_id = avis;
          it.count = this.adults_select;
          pax.push(it);
          lngtot =
            lngtot + parseFloat(fincustprices.Adult) * parseInt(fincust.Adult);
        }
        if (key == "Child") {
          let it = {};
          it.visitor_type_id = cvis;
          it.count = this.children_select;
          pax.push(it);
          lngtot =
            lngtot + parseFloat(fincustprices.Child) * parseInt(fincust.Child);
        }
        if (key == "Infant" && this.infants_select > 0) {
          let it = {};
          it.visitor_type_id = ivis;
          it.count = this.infants_select;
          pax.push(it);
          lngtot =
            lngtot +
            parseFloat(fincustprices.Infant) * parseInt(fincust.Infant);
        }
      }
      let lng_order_ref = "";
      let orefwithoutprefix = encryptStorage.getItem("orefwithoutprefix");
      if (typeof orefwithoutprefix !== "undefined") {
        orefwithoutprefix = encryptStorage.getItem("orefwithoutprefix");
      } else {
        orefwithoutprefix = new Date().getTime();
        encryptStorage.setItem("orefwithoutprefix", orefwithoutprefix);
      }
      lng_order_ref = this.setbrandid + "-LNG-" + orefwithoutprefix;
      lngtot = lngtot.toFixed(2);
      this.loungesubtotal = lngtot;

      let lounge = {
        brand_id: this.setbrandid,
        orefwithoutprefix: orefwithoutprefix,
        lng_order_ref: lng_order_ref,
        package_id: package_id,
        venue_id: this.venue_select,
        venue_select_name: this.venue_select_name,
        lounge_id: lounge_id,
        ADL: fincust.Adult,
        CHD: fincust.Child,
        INF: fincust.Infant,
        ADL_PR: fincustprices.Adult,
        CHD_PR: fincustprices.Child,
        INF_PR: fincustprices.Infant,
        guid: guid,
        date_selected: this.date1_date,
        date_selected_display: date_selected_display,
        time_selected: this.date1_time,
        loungesubtotal: this.loungesubtotal,
        product_name: product_name,
        crossell: "Yes",
      };
      console.log("loungecart", lounge);
      encryptStorage.setItem("lounge_cart", lounge);

      encryptStorage.setItem("lng_order_ref", lng_order_ref);
      let datacart = {};
      datacart = {
        brand_id: this.setbrandid,
        venue_id: this.venue_select,
        lounge_id: lounge_id,
        package_id: package_id,
        booking_ref_id: lng_order_ref,
        uuid: guid,
        valid_from: this.date1_date,
        start_time: this.date1_time,
        visitors: pax,
      };

      let secsa = genkeys(
        encryptStorage.getItem("rez_dev_k").VUE_APP_LOUNGE_RESERVE_SECRETID,
        encryptStorage.getItem("rez_dev_k").VUE_APP_LOUNGE_RESERVE_SECRETKEY
      );
      let b1s = secsa.b1s;
      let v2s = secsa.v2s;
      let a1 = secsa.a1;
      let v1 = secsa.v1;
      let c2s = secsa.c2s;
      let uidgen = secsa.uidgen;

      axios
        .post(
          encryptStorage.getItem("rez_dev_k").VUE_APP_DOMAIN_LIVESSO +
            "lounge/frontend/package/booking/reserve",
          datacart,
          {
            headers: {
              b1: b1s,
              v2: v2s,
              c2s: c2s,
              a1: a1,
              v1: v1,
              c1: uidgen,
              "Content-Type": "application/json",
            },
          }
        )
        .then((response) => {
          if (response.data.user_exists == "Y") {
            encryptStorage.setItem("crosssell_in_cart", "Yes");
            //window.location.href = "/yourdetails.html";
            let update_basket = new CustomEvent("update_basket", {
              detail: {
                basket: "update",
              },
            });
            window.dispatchEvent(update_basket);
          }
          setTimeout(() => {
            this.add_to_basket_loader = false;
          }, 1000);
        });
    },

    set_results_subheadline() {
      //"11 Dec 2021 at 9:00 am - 11 Dec 2021 at 9:00 am";
      if (this.date1_date && this.date1_time) {
        this.results_subheadline =
          this.format_date_with_locale(this.date1_date, "date") +
          " " +
          this.getrans("at") +
          " " +
          this.format_date_with_locale(
            this.date1_date + " " + this.date1_time,
            "time"
          );

        if (this.adults_select) {
          let adult_string = "";
          if (Number(this.adults_select) > 1) {
            adult_string = this.getrans("Adults");
            this.results_subheadline +=
              ", " + this.adults_select + " " + adult_string;
          } else if (Number(this.adults_select) === 1) {
            adult_string = this.getrans("Adult");
            this.results_subheadline +=
              ", " + this.adults_select + " " + adult_string;
          }
        }

        if (this.children_select) {
          let children_string = "";
          if (Number(this.children_select) > 1) {
            children_string = this.getrans("Children");
            this.results_subheadline +=
              ", " + this.children_select + " " + children_string;
          } else if (Number(this.children_select) === 1) {
            children_string = this.getrans("Child");
            this.results_subheadline +=
              ", " + this.children_select + " " + children_string;
          }
        }

        if (this.infants_select) {
          let infants_string = "";
          if (Number(this.infants_select) > 1) {
            infants_string = this.getrans("Infants");
            this.results_subheadline +=
              ", " + this.infants_select + " " + infants_string;
          } else if (Number(this.infants_select) === 1) {
            infants_string = this.getrans("Infant");
            this.results_subheadline +=
              ", " + this.infants_select + " " + infants_string;
          }
        }

        if (this.senior_select) {
          let senior_string = "";
          if (Number(this.senior_select) > 1) {
            senior_string = this.getrans("Seniors");
            this.results_subheadline +=
              ", " + this.senior_select + " " + senior_string;
          } else if (Number(this.senior_select) === 1) {
            senior_string = this.getrans("Senior");
            this.results_subheadline +=
              ", " + this.senior_select + " " + senior_string;
          }
        }

        //console.log("this.adults_select", this.adults_select);
        //console.log("this.getrans('Adults')", this.getrans("Adults"));
        //console.log("this.getrans('Adult')", this.getrans("Adult"));
        //console.log("this.results_subheadline", this.results_subheadline);

        this.actcustomers["Adult"] = Number(this.adults_select);
        this.actcustomers["Child"] = Number(this.children_select);
        this.actcustomers["Infant"] = Number(this.infants_select);
        this.actcustomerprices["Adult"] = 0;
        this.actcustomerprices["Child"] = 0;
        this.actcustomerprices["Infant"] = 0;
        console.log("this.actcustomers", this.actcustomers);
        this.set_results_quantitys();
      }
    },
  },
  mounted() {
    //this.venue_select = this.crosssell_data_passed.data[0].sub_venue_id;

    // this.loading_data_widget = false;
    // this.expanded_results[0] = true;
    // this.expanded_widget[0] = false;
    // this.expanded[0] = true;

    //this.buttonisActive = true;
    this.crosssell_data = encryptStorage.getItem("crosssell_data");
    console.log("this.crosssell_data", this.crosssell_data.data);
    this.cross_sell_lounge_suggested = [];
    if (this.crosssell_data.data) {
      this.crosssell_data.data.forEach((item) => {
        if (item.suggestion_product_id === "lng") {
          console.log("item", item);
          this.discount_value = parseFloat(item.discount_value);
          let lounge_id_suggested = item.api_data[0].lounge_id;
          this.visitortypes = item.api_data[0].calculations[0].visitor_types;
          this.cross_sell_lounge_suggested.push(lounge_id_suggested);
          this.venue_select = item.sub_venue_id.toString();
          this.final_amount = parseFloat(item.final_amount);
          console.log("lounge_id_suggested", lounge_id_suggested);
          console.log("this.final_amount", this.final_amount);
          this.date1_date = item.valid_from.replaceAll("-", "/");
          this.date1_time = item.start_time;

          this.date1_forwidget = this.date1_date + " " + this.date1_time;
          for (let a = 0; a < this.visitortypes.length; a++) {
            let an = this.visitortypes[a];
            if (an.system_visitor_type_name == "Adult") {
              this.adults_select = an.count;
            }
            if (an.system_visitor_type_name == "Child") {
              this.children_select = an.count;
            }
            if (an.system_visitor_type_name == "Infant") {
              this.infants_select = an.count;
            }
          }
          this.refresh_widget++;
        }
      });
      console.log(
        "this.cross_sell_lounge_suggested",
        this.cross_sell_lounge_suggested
      );
    }

    //  this.date1_forwidget =
    //     this.correctdate(urlParams.get("date1_date")) +
    //     " " +
    //     urlParams.get("date1_time");
    //   this.date2_forwidget =
    //     this.correctdate(urlParams.get("date2_date")) +
    //     " " +
    //     urlParams.get("date2_time");

    //this.getbranded();

    window.addEventListener(
      "search-emit",
      (event) => {
        console.log("got search-emit event", event.detail.data);
        if (event.detail.data.tab !== "Lounge") {
          return false;
        }

        if (this.noSlotsAvailable) {
          this.noSlotsAvailable = false;
          this.dataloaded = false;
        }

        this.manual_search = true;
        this.loading_data_widget = true;
        // this.getbranded();
        console.log("event emit", JSON.stringify(event));
        this.date1_date = this.formatDateymd(event.detail.data.date1);
        this.date1_time = `${event.detail.data.date1_time}`;

        // this.date2_date = event.detail.data.date2_date;
        // this.date2_time = event.detail.data.date2_time;
        this.adults_select = `${event.detail.data.adults_select}` || ``;
        this.children_select = `${event.detail.data.children_select}` || ``;

        if (this.infants_select) {
          this.infants_select = `${event.detail.data.infants_select}` || ``;
        }
			this.infants_select = 0;
        this.senior_select = `${event.detail.data.senior_select}` || ``;

        this.venue_select = `${event.detail.data.venue_select}`;
        this.venue_name = `${event.detail.data.venue_select_name}`;

        this.search_origin = `${event.detail.data.search_origin}`;

        //this.setLocalData("venue_selected", this.venue_select);

        console.log("this.date1_date, this.date1", this.date1_date);
        console.log("this.venue_name, this.venue_name", this.venue_name);
        console.log("this.date1_date, this.date1_date", this.date1_date);
        console.log("this.date1_time, this.date1_time", this.date1_time);
        this.crosssellcheck();
      },
      false
    );
    let datacsl = encryptStorage.getItem("datacsl");
    this.venue_select_name = datacsl.venue_select_name;
    setTimeout(() => {
      this.getbranded();
      encryptStorage.setItem("crosssell_shown", "Yes");
      //this.getBrandData();
      //sessionStorage.clear();
    }, 200);

    // setTimeout(() => {
    //   this.children_select = "2";
    //   this.getbranded();
    // }, 5000);
  },

  updated() {},
};
</script>

<style lang="scss">
.results_expanded_description ul {
  padding: 1rem;
  margin: 0;
  li {
    margin-bottom: 0.5rem;
  }
}
</style>

<style scoped lang="scss">
@import "@/assets/sass/variables.scss";

.results-fade.not-loaded {
  opacity: 0;
}

.results-fade {
  overflow: hidden;
  opacity: 1;
  transition: opacity 1s ease;
}

.results {
  max-width: calc(1280px + 2rem);
  // padding: 0 1rem;
  // margin: 3rem auto;
  background: #fff;

  &-container {
    margin-top: 3.75rem;
    @media screen and (max-width: 768px) {
      margin-top: 1rem;
    }
  }

  &_box {
    max-width: 1280px;
    margin: 0 auto 1rem;
    @media screen and (max-width: 767px) {
      margin: 0 auto 1rem;
    }
    width: 100%;
    box-shadow: 0px 3px 6px #00000029;
    border: 1px solid #dfdfdf;
  }
  &_top {
    display: flex;
    @media screen and (max-width: 767px) {
      flex-direction: column;
    }
    &_image_title_description {
      width: 100%;
      display: flex;
    }
    &_image {
      flex: 0;
      align-self: flex-start;
      max-width: 175px;
      @media screen and (max-width: 959px) {
        width: 180px;
      }
      @media screen and (max-width: 767px) {
        width: 33%;
        display: none;
      }
      height: auto;
      background: #ddd;
    }
    &_title_description {
      width: 100%;
      padding: 1.5rem;
      @media screen and (max-width: 959px) {
        padding: 1rem;
      }
    }
    &_title {
      font-size: 1.25rem;
      color: #1a2a40;
    }
    &_description {
      font-size: 1rem;
      color: #707070;
    }
    &_price_button {
      width: auto;
    }
    &_price_button {
      display: flex;
      flex-direction: column;
      @media screen and (max-width: 767px) {
        flex-direction: row;
      }
      justify-content: space-between;
      align-items: center;
      min-width: 175px;
      border-left: 1px solid #ddd;

      del {
        font-size: 1.2rem;
        color: #999;
        display: inline-block;
        padding-right: 0.5rem;
      }

      .notes {
        font-size: 1.2rem;
        color: #999;
        display: block;
        font-size: 1rem;
      }
    }
    &_price {
      padding: 1rem 1rem;
      flex: 1;
      display: flex;
      @media screen and (min-width: 767.98px) {
        flex-direction: column;
      }
      justify-content: center;
      @media screen and (max-width: 767px) {
        justify-content: flex-start;
        padding: 0rem 1rem;
        align-items: baseline;
      }
      align-items: center;
      color: #707070;
      font-size: 1.25rem;
      text-align: center;
      b {
        font-size: 1.75rem;
        color: #1a2a40;
      }
      @media screen and (max-width: 767px) {
        justify-content: center;
        align-items: baseline;
        padding: 0rem 1rem;
        font-size: 1rem;
        b {
          font-size: 1.3rem;
          color: #1a2a40;
        }
      }
    }
    &_button {
      flex: 0;
      @media screen and (max-width: 767px) {
        flex: 1;
      }
      width: 100%;
      button {
        padding: 1.25rem 1rem;
        @media screen and (max-width: 959px) {
          padding: 1rem 1rem;
          font-size: 1rem;
        }
        width: 100%;
        background-color: var(--result_button_expand_background, #034a94);
        color: var(--result_button_expand_font_color, #ffffff);
        border: none;
        font-size: var(--result_button_expand_font_size, 1.325rem);
        font-weight: var(--result_button_expand_font_weight, bold);
        font-family: var(--result_button_expand_font_family, inherit);
      }
      button:disabled {
        filter: saturate(0);
        cursor: not-allowed;
      }
    }
  }
}

.results_expanded {
  &_wrapper {
    display: flex;
    @media screen and (max-width: 767px) {
      flex-direction: column;
    }
    border-top: 1px solid #dfdfdf;
  }
  &_title_description {
    width: 100%;
    padding: 1.5rem;
    @media screen and (max-width: 959px) {
      padding: 1rem;
    }
    @media screen and (max-width: 767px) {
      padding: 1rem;
      padding-bottom: 0rem;
    }
    p {
      margin-bottom: 0;
    }
    ul {
      margin: 0;
      padding: 0;
    }
  }
  &_title {
    font-size: 1.25rem;
    color: #1a2a40;
  }
  &_description {
    font-size: 1rem;
    color: #707070;
  }
  &_price_quantity {
    display: flex;
    flex-wrap: wrap;
    flex-direction: column;
    @media screen and (max-width: 767px) {
      flex-direction: row-reverse;
      border-left: 0px solid #ddd;
    }
    justify-content: space-between;
    align-items: center;
    min-width: 275px;
    border-left: 1px solid #ddd;
  }
  &_price {
    padding: 1rem 1rem;
    @media screen and (max-width: 767px) {
      padding: 0rem 1rem;
    }
    flex: 1;
    display: flex;
    justify-content: center;
    align-items: flex-end;
    @media screen and (max-width: 767px) {
      justify-content: flex-end;
    }
    color: #707070;
    font-size: 1rem;
    b {
      font-size: 1.25rem;
      color: #1a2a40;
    }
  }
  &_quantity {
    padding: 1rem 1rem 1rem;
    flex: 1;
    @media screen and (max-width: 959px) {
      padding: 1rem;
      flex: 0;
    }
    display: flex;
    justify-content: center;
    align-items: center;
  }
  > div:nth-child(odd) {
    background: #f5f5f5;
  }
}

.results_add {
  box-sizing: border-box;
  display: flex;
  @media screen and (max-width: 767px) {
    flex-direction: column;
  }
  align-items: center;
  border-top: 1px solid #dfdfdf;
  &_subtotal {
    padding: 0rem 2rem;
    @media screen and (max-width: 959px) {
      padding: 0rem 1rem;
    }
    @media screen and (max-width: 767px) {
      padding: 1rem;
    }
    flex: 1;
    align-items: baseline;
    color: #1a2a40;
    font-size: 1.25rem;
    b {
      font-size: 1.75rem;
      color: #2370a1;
    }
  }
  &_button {
    flex: 0;
    @media screen and (max-width: 767px) {
      flex: 1;
      width: 100%;
    }
    min-width: 275px;
    button {
      padding: 1.25rem 1rem;
      @media screen and (max-width: 959px) {
        padding: 1rem 1rem;
        font-size: 1rem;
      }
      width: 100%;
      background-color: var(--result_button_primary_background, #034a94);
      color: var(--result_button_primary_font_color, #fff);
      border: none;
      font-size: 1.325rem;
      font-weight: bold;
    }
    button:disabled {
      filter: saturate(0);
      cursor: not-allowed;
    }
  }
}

.quantity-selector {
  display: flex;
  button {
    padding: 0.75rem;
    display: flex;
    justify-content: center;
    align-items: center;
    border: none;
    background: #dfdfdf;
    color: #1a2a40;
  }
  select {
    border: 1px solid #dfdfdf;
    padding: 0.75rem;
    cursor: pointer;
  }
}

.date_search {
  padding: 1rem;
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-top: 1px solid #dfdfdf;
  border-bottom: 1px solid #dfdfdf;
}

.loading-results {
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  font-size: 1.275rem;
  color: #555;
  padding: 3rem 1rem;
  max-width: 1280px;
  margin: 0 auto 1rem;
  width: 100%;
  box-shadow: 0px 3px 6px #00000029;
  border: 1px solid #dfdfdf;
  background: #fff;
  .search-widget {
    width: 100%;
  }
}

.search-dates {
  color: var(--basket_price_font_color, #236ca3);
}

.edit-search {
  background: #e9e7e7;
  box-shadow: 0 2px 2px 0 #0000002e;
  border: 0px;
  font-size: 1rem;
  padding: 0.5rem 1rem;
  font-weight: bold;
  color: #236ca3;
}
</style>
